var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordDisplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.542 12.981C20.572 11.494 18.369 9 14.5 9c-3.869 0-6.073 2.494-7.042 3.981-.3.456-.458.982-.458 1.519 0 .537.159 1.063.458 1.519C8.428 17.506 10.631 20 14.5 20c3.869 0 6.073-2.494 7.042-3.981.3-.456.458-.982.458-1.519 0-.537-.159-1.063-.458-1.519zm-1.066 2.422c-.832 1.275-2.715 3.42-5.976 3.42-3.26 0-5.144-2.145-5.977-3.42a1.644 1.644 0 0 1-.272-.903c0-.319.094-.632.272-.903.833-1.275 2.716-3.42 5.977-3.42 3.26 0 5.144 2.143 5.977 3.42.177.271.272.584.272.903 0 .319-.095.632-.272.903z",
    fill: "#516888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm0 5.6a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2z",
    fill: "#516888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordDisplay);
export default __webpack_public_path__ + "static/media/passwordDisplay.d3db9ce027733d53e5d6f3b474ef2b17.svg";
export { ForwardRef as ReactComponent };